<template>
	<div class="main-content-padding">
		<Panel :contentPaddingTop="12" class="shopLibrary">
			<div class="recycle-public">
				<!-- 回收站 -->
				<div v-if="$auth.hasPermi('system:waste:query')" class="flex">
					<div class="recycleBin fz-14" @click="recycleFun">
						<i class="el-icon-delete"></i>
						<span class="ml-8">回收站</span>
					</div>
					<div v-if="showShopPublicShare" class="line"></div>
				</div>
				<!-- 商品库公开选品 -->
				<div class="public yx-color-text-primary fz-14" @click="publicFun" v-if="showShopPublicShare">
					<el-tooltip class="item" effect="dark" placement="top" content="商品库下所有推广中的商品进行公开选品">
						<p class="flex-row flex-just-center">
							<i class="iconfont mr-6 mt-2">&#xe6a4;</i>
							<span>分享选品中心</span>
						</p>
					</el-tooltip>
				</div>
				<!--只有抖音有 商品流转记录---->
				<div class="flex flex-align-center" v-if="$isPlatOr(['Dy', 'Ks']) && $auth.hasPermi('system:goods:flowRecord')">
					<div class="line"></div>
					<span class="ml-8 fz-14 transfer-record yx-color-primary" @click="showGoodsRecord()">商品流转记录</span>
					<span class="red-dot ml-4" v-if="showTips"></span>
				</div>
			</div>
			<platformTab @change="handleClick" :showAll="false" :platformId="platformId"></platformTab>

			<Tip :type="'warning'" class="tips-content" :showCloseIcon="true" v-if="isTrialAccount">
				<div class="ml-6 font-h6-regular yx-color-text-primary cursor-pointer" slot="content">
					您的账号为超佣团试用账号，试用账号每日不自动更新商品信息，如有商品信息变动需手动点击【同步商品】按钮
				</div>
			</Tip>
			<search
				v-show="showPlatformContent"
				@clearImminent="clearImminent"
				ref="search"
				@onSubmit="onSubmit"
				:platformId="platformId"
				@clear="onClear"
			></search>
		</Panel>
		<Panel v-show="showPlatformContent">
			<div class="multi-table" v-loading="loading">
				<div v-if="+platformId === platformId" :class="[showTable ? '' : 'extraMb']">
					<div class="tab-btn flex flex-align-center flex-just-between">
						<div class="flex flex-align-center">
							<div class="ml-14 mr-18" v-if="!showTable">
								<el-checkbox @change="checkeFun" v-model="allChecked">当页全选</el-checkbox>
							</div>
							<span class="mr-10 yx-color-text-regular fz-14">
								已选
								<span class="yx-color-primary">{{ selectionShopArr.length }}</span>
							</span>
							<el-tooltip
								v-if="$auth.hasPermi('system:goods:sampleRequest')"
								:disabled="!!selectionShopArr.length"
								content="请先选择商品"
								placement="top"
							>
								<el-button @click="batchSample" style="border: 1px solid #2475ff; color: #2475ff">申样</el-button>
							</el-tooltip>
							<div class="ml-10 mr-10" v-if="$auth.hasPermi('system:goods:promote')">
								<el-tooltip content="请先选择商品" :disabled="!!selectionShopArr.length" placement="top">
									<el-button @click="recommend" style="border: 1px solid #2475ff; color: #2475ff">推荐商品给达人</el-button>
								</el-tooltip>
							</div>
							<div class="mr-10">
								<el-tooltip
									v-if="$auth.hasPermi('system:goods:unsample-broadcasting')"
									:disabled="!!selectionShopArr.length"
									content="请先选择商品"
									placement="top"
								>
									<el-button @click="unlimitedBroadcasting">无样开播</el-button>
								</el-tooltip>
							</div>

							<div v-if="$auth.hasPermi('system:shopLibrary:export')" class="mr-10">
								<export-list
									ref="exportList"
									:routerPath="routerPath"
									:platformId="platformId"
									:exportInterface="exportInterface"
									:exportDialog="exportDialog"
									:isExportImg="true"
									:isExportSku="true"
								></export-list>
							</div>
							<el-dropdown size="small" trigger="click">
								<el-button>
									其他操作
									<i class="el-icon-arrow-down el-icon--right"></i>
								</el-button>
								<el-dropdown-menu slot="dropdown" class="dropdownPop">
									<el-dropdown-item>
										<template v-if="$auth.hasPermi('system:shopLibray:goodGroup')">
											<join-dialog :platformId="platformId" :selectionShopArr="selectionShopArr" ref="joinDialog"></join-dialog>
										</template>
									</el-dropdown-item>
									<el-dropdown-item>
										<el-tooltip
											v-if="$auth.hasPermi('system:goods-batch-allocation')"
											content="请先选择商品"
											:disabled="!!selectionShopArr.length"
											placement="top"
										>
											<el-button @click="bachDistribution()" type="primary">批量分配商品</el-button>
										</el-tooltip>
									</el-dropdown-item>
									<el-dropdown-item>
										<el-tooltip
											v-if="$auth.hasPermi('system:shopLibray:batch-add-material')"
											content="请先选择商品"
											:disabled="!!selectionShopArr.length"
											placement="top"
										>
											<el-button @click="addMaterial(1, selectionShopArr)" type="primary">批量添加素材</el-button>
										</el-tooltip>
									</el-dropdown-item>
									<el-dropdown-item>
										<el-tooltip
											v-if="$auth.hasPermi('system:shopLibray:deleteGood')"
											content="请先选择商品"
											:disabled="!!selectionShopArr.length"
											placement="top"
										>
											<el-button @click="batchDelete()" type="primary">批量删除商品</el-button>
										</el-tooltip>
									</el-dropdown-item>
									<el-dropdown-item>
										<template v-if="$auth.hasPermi('system:shpopLibray:SampleMk')">
											<BatchEditApplySampleRulesButton :selectedArr="selectionShopArr"></BatchEditApplySampleRulesButton>
										</template>
									</el-dropdown-item>
									<el-dropdown-item>
										<el-tooltip content="请先选择商品" :disabled="!!selectionShopArr.length" placement="top">
											<el-button @click="addTags" v-if="$auth.hasPermi('system:shopLibray:addTag')">添加标签</el-button>
										</el-tooltip>
									</el-dropdown-item>
									<el-dropdown-item>
										<el-tooltip
											v-if="$isDy(platformId) && $auth.hasPermi('system:shopLibray:Prolonging-batch-good')"
											content="请先选择商品"
											:disabled="!!selectionShopArr.length"
											placement="top"
										>
											<el-button @click="extensionChange" type="primary">批量延长推广</el-button>
										</el-tooltip>
									</el-dropdown-item>
								</el-dropdown-menu>
							</el-dropdown>
							<button-group v-if="$auth.hasPermi('system:goods-synchronous')">
								<dy-goods-async-button
									v-if="$isPlatOr(platformId, ['Dy', 'Sp'])"
									ref="goodsAsyncBtn"
									needAuth
									:platformId="platformId"
									@refresh="getShopList"
								></dy-goods-async-button>
								<goods-async-button
									v-else
									ref="goodsAsyncBtn"
									needAuth
									:platformId="platformId"
									:sync_info="sync_info"
									type="multiTask"
									@refresh="getShopList"
								></goods-async-button>
								<!-- <el-tooltip
									v-if="$isPlatOr(platformId, ['Dy']) && $auth.hasPermi('system:shop:doubleCommision')"
									content="请先勾选商品并保持插件登录状态下，点击该按钮同步所选商品的双佣金信息"
									:disabled="!!selectionShopArr.length"
									placement="top"
								>
									<el-button class="ml-10" @click="getDoubleCommissionForPlugin()" type="primary">同步商品双佣金</el-button>
								</el-tooltip> -->
							</button-group>
						</div>

						<!-- 切换列表及列表开关 -->
						<div class="flex flex-align-center">
							<div class="switch-wrap ml-10">
								<i title="切换为卡片视图" :class="{ active: !showTable }" class="iconfont icon-gonggebeifen" @click="modeSwitch(0)"></i>
								<div class="line"></div>
								<i title="切换为列表视图" :class="{ active: showTable }" class="iconfont icon-liebiao" @click="modeSwitch(1)"></i>
							</div>
						</div>
					</div>
					<div class="flex flex-align-center flex-just-between mt-20">
						<div class="flex flex-align-center">
							<div :class="['pointer fz-14 ml-10', sortType === 0 ? 'yx-color-primary font-bold' : 'yx-color-text-p-4']" @click="searchClick(0)">
								综合排序
							</div>
							<div :class="['pointer fz-14 ml-16', sortType === 1 ? 'yx-color-primary font-bold' : 'yx-color-text-p-4']" @click="searchClick(1)">
								上新时间
							</div>
							<div
								v-if="$isKs()"
								:class="['pointer fz-14 ml-16', sortType === 2 ? 'yx-color-primary font-bold' : 'yx-color-text-p-4']"
								@click="searchClick(2)"
							>
								商品销量
							</div>
							<div v-if="!showTable" class="flex flex-align-center">
								<div class="flex flex-align-center ml-16" @click="searchClick(3)">
									<div class="pointer fz-14 yx-color-text-p-4">佣金率</div>
									<div class="ml-2">
										<i
											:class="[
												sortType === 3 && sort_desc === 'asc' ? 'yx-color-primary font-bold ' : 'yx-color-text-p-4',
												'caret-block el-icon-caret-top',
											]"
										></i>
										<i
											:class="[
												sortType === 3 && sort_desc === 'desc' ? 'yx-color-primary font-bold ' : 'yx-color-text-p-4',
												'caret-block el-icon-caret-bottom',
											]"
										></i>
									</div>
								</div>
								<div class="flex flex-align-center ml-16" @click="searchClick(4)">
									<div class="pointer fz-14 yx-color-text-p-4">服务费率</div>
									<div class="ml-2">
										<i
											:class="[
												sortType === 4 && sort_desc === 'asc' ? 'yx-color-primary font-bold ' : 'yx-color-text-p-4',
												'caret-block el-icon-caret-top',
											]"
										></i>
										<i
											:class="[
												sortType === 4 && sort_desc === 'desc' ? 'yx-color-primary font-bold ' : 'yx-color-text-p-4',
												'caret-block el-icon-caret-bottom',
											]"
										></i>
									</div>
								</div>
							</div>
						</div>
						<div>
							<div class="mr-12" v-if="isShopPartnerDataView">
								<el-checkbox v-model="checked" @change="onlyFun">仅看自己负责的商品</el-checkbox>
							</div>
							<div class="mr-12">
								<el-checkbox
									v-if="$auth.hasPermi('view:local-material')"
									v-model="has_material"
									@change="getShopList()"
									:true-label="1"
									:false-label="0"
								>
									已添加素材
								</el-checkbox>
								<el-checkbox
									v-if="$auth.hasPermi('system:goods:commissionRate')"
									v-model="has_open_commission_rate"
									:true-label="1"
									:false-label="0"
									@change="getShopList()"
								>
									已公开佣金
									<el-tooltip content="小程序素材库所展示的商品佣金率，可从[操作-修改素材]中更改" placement="top-end">
										<i style="color: #86909d; font-size: 12px" class="el-icon-question"></i>
									</el-tooltip>
								</el-checkbox>
								<el-checkbox v-model="checkedImminent" @change="onlyFunImminent">{{ $isSp(platformId) ? '临期商品' : '临期活动商品' }}</el-checkbox>
								<el-tooltip content="7天内活动将到期，请及时延长推广时间避免产生资损" placement="top-end">
									<i style="color: #86909d; font-size: 12px; margin-left: 4px" class="el-icon-question"></i>
								</el-tooltip>
							</div>
						</div>
					</div>

					<product-wrap
						class="product-wrap"
						v-show="!showTable"
						ref="productWrap"
						:list="list"
						@setTableCheckList="setTableCheckList"
						@refresh="addTag"
					>
						<empty
							v-if="!showTable"
							:isSearch="isSearch"
							slot="empty"
							:hasGoods="!noGoods"
							@btnClick="synchroFun(platformId)"
							:platformId="platformId"
							source="library"
						></empty>
					</product-wrap>
					<multi-table
						:class="[showTable ? 'active-table-content' : 'table-content', showTable ? 'mt-24' : '']"
						class="muti-table"
						ref="multiTable"
						:selectionChange="selectionChange"
						:columns="filterColumns"
						@gePartnerList="gePartnerList"
						@getSortList="onSort"
						:list="list"
						:options="options"
						:total="total"
						:page="pageInfo"
						:defaultSort="defaultSort"
					>
						<empty
							v-if="showTable"
							:isSearch="isSearch"
							slot="empty"
							:hasGoods="!noGoods"
							@btnClick="synchroFun(platformId)"
							:platformId="platformId"
							source="library"
						></empty>
					</multi-table>
				</div>
			</div>
		</Panel>
		<remark-dialog ref="remarkDialog" @saveRemark="saveRemark"></remark-dialog>
		<editShop-dialog ref="editShopDialog" @refreshList="getShopList"></editShop-dialog>
		<handCard-dialog ref="handCardDialog" @refreshList="getShopList"></handCard-dialog>
		<shareDrawer ref="shareDrawer" :key="timer"></shareDrawer>
		<!-- <join ref="join"></join> -->
		<publicDialog ref="publicDialog"></publicDialog>
		<del-dialog ref="delDialog" @delSuccess="getShopList"></del-dialog>
		<anew-allocation-dialog :platformId="platformId" ref="anewAllocationDialog" @refreshList="getShopList" />
		<recommendDrawer ref="recommendDrawer" :platformId="platformId" :total="total"></recommendDrawer>
		<tagDialog ref="tagDialog" @refreshList="getShopList"></tagDialog>
		<EditSampleRuleDialog :platformId="platformId" @refresh="getShopList"></EditSampleRuleDialog>
		<DialogDelayPromotion ref="dialogDelayPromotion" @refreshList="getShopList" />

		<!-- 批量申样 -->
		<apply-sample-drawer ref="applySampleDrawer" :platformId="platformId" @refreshList="getShopList" />

		<!--批量分配-->
		<distribution :platformId="platformId" @refreshList="getShopList" ref="distribution" :selectionShopArr="selectionShopArr"></distribution>

		<!--无样开播-->
		<sample-free-broadcast-drawer ref="sampleFreeBroadcastDrawer" :platformId="platformId" @refreshList="getShopList" />

		<!--批量延长推广-->
		<extension-drawer ref="extensionDrawer" @refreshList="getShopList"></extension-drawer>

		<!--商品流转记录-->
		<flowGoodsDrawer ref="flowGoodsDrawer" @refresh="flowRecordNew" :platformId="platformId"></flowGoodsDrawer>
	</div>
</template>
<script>
import { mapGetters, mapState } from 'vuex';
import getColums from './columns';
import search from './components/search.vue';
import publicDialog from './components/public.vue';
import joinDialog from './components/joinDialog.vue';
// import join from '@/views/common/dialog/join.vue';
import shareDrawer from '@/views/common/dialog/shareDrawer.vue';
import debounce from 'lodash/debounce';
import Empty from '@/views/shopManage/components/goodsEmpty.vue';
import remarkDialog from '@/views/shopManage/components/remarkDialog.vue';
import recommendDrawer from '@/views/shopManage/components/recommendDrawer';
import editShopDialog from '@/views/shopManage/components/editShopDialog.vue';
import handCardDialog from '@/views/shopManage/components/handCardDialog.vue';
import productWrap from './components/productWrap';
import anewAllocationDialog from './components/anewAllocationDialog';
import { productList, editField, cancelReceive, productInfoExport, setProductTop, delProductTop, getProductClaimLogRecord, cacheDoubleCommissionProducts } from '@/api/shopManage';
import { arrSort } from '@/utils/common';
import delDialog from '@/views/common/dialog/delete.vue';
import { platformMixin } from '@rd/rd-ui';
import GoodsAsyncButton from '@/modules/async/goods';
import dyGoodsAsyncButton from '@/modules/dyAsync/goods';
import ButtonGroup from '@/components/ui/buttonGroup';
import { menuType, promoteStatus, zsRoleType } from '@/utils/dataMap';
import exportList from '@/views/common/exportList';
import tagDialog from '@/components/business/tagDialog';
import EditSampleRuleDialog from '@/modules/sample/apply/rules/editDialog';
import BatchEditApplySampleRulesButton from '@/modules/sample/apply/rules/batchButton';
import DialogDelayPromotion from './components/dialogDelayPromotion.vue';
import applySampleDrawer from '@/components/business/applySampleDrawer';
// import DropButton from '@/components/ui/dropButton';
import distribution from '../../tobeClaimed/list/components/distribution.vue';
import sampleFreeBroadcastDrawer from '@/components/business/sampleFreeBroadcastDrawer';
import extensionDrawer from '../../components/extensionDrawer/extensionDrawer.vue';
import flowGoodsDrawer from '@/components/business/flowGoodsDrawer/flowGoodsDrawer.vue';
import { callPlug } from '@/utils/bridge';
export default {
	name: 'shopLibrary',
	components: {
		search,
		publicDialog,
		joinDialog,
		remarkDialog,
		editShopDialog,
		handCardDialog,
		// join,
		delDialog,
		shareDrawer,
		productWrap,
		anewAllocationDialog,
		applySampleDrawer,
		recommendDrawer,
		Empty,
		exportList,
		GoodsAsyncButton,
		dyGoodsAsyncButton,
		ButtonGroup,
		tagDialog,
		EditSampleRuleDialog,
		BatchEditApplySampleRulesButton,
		DialogDelayPromotion,
		distribution,
		sampleFreeBroadcastDrawer,
		extensionDrawer,
		flowGoodsDrawer,
	},
	mixins: [platformMixin],
	data() {
		return {
			checked: false,
			list: [],
			options: {
				selectable: true,
				border: false,
			},
			pageInfo: {
				page_index: 1,
				page_size: 20,
			},
			platformId: '',
			total: '0',
			selectionShopArr: [],
			allChecked: '',
			params: {
				platform_id: '1',
			},
			showTable: false,
			wxImgUrl: '',
			timer: '',
			isSearch: false,
			routerPath: '/shopManage/shopLibrary/record',
			noGoods: true,
			loading: false,
			sysgenCard: {},
			ids: [],
			checkedImminent: false,
			sync_info: {},
			sortType: 0,
			pageConfig: { page_size: 20 },
			addNewArr: [
				{
					label: '综合排序',
					value: 0,
				},
				{
					label: '上新时间',
					value: 1,
				},
			],
			showTips: false, //是否有新的流转记录标识 抖音平台
			has_open_commission_rate: 0,
			has_material: 0,
			sort_desc: '',
			lastSortType: -1,
			defaultSort: {},
		};
	},
	computed: {
		...mapGetters(['defaultPlatform', 'isDrPartnerDataView', 'isShopPartnerDataView', 'isTrialAccount']),
		...mapState(['vuex_userInfo']),
		rate_status() {
			return this.vuex_userInfo?.rate_status;
		},
		filterColumns() {
			let newArr = getColums(this).filter(val => val.isShow);
			return newArr;
		},
		showShopPublicShare() {
			return this.$auth.hasPermiAnd(['system:goods:promote', 'WeChat:CommodityManageShareCYT']);
		},
		zsName() {
			return zsRoleType.name;
		},
		addNewText({ sortType }) {
			return this.addNewArr.filter(val => val.value === sortType)[0]?.label;
		},
	},
	created() {
		this.params.other_status = 1;
		// 如果切换成招商运营视角 默认传 '1'
		// this.params.view_self = this.isShopPartnerDataView ? '1' : '0';
		let id = this.$route.query.id || '';
		if (id) {
			this.params.tag_ids = id;
			this.getShopList();
		}
		//如果内容库跳转到商品库
		if (this.$route.query.materialId) {
			this.params.material_id = this.$route.query?.materialId || '';
			this.getShopList();
		}
		this.showTable = !this.$auth.hasPermi('system:goods:promote');
	},
	mounted() {
		this.$Bus.$on('applicationSetting', form => {
			this.showTable = !!(form.show_style || 0);
		});
	},
	methods: {
		handleClick(val) {
			this.platformId = val;
			if (!this.showPlatformContent) return;
			this.allChecked = false;
			this.checked = false;
			this.selectionShopArr = [];
			this.pageInfo = {
				page_index: 1,
				page_size: 20,
			};
			this.params = {
				other_status: 1,
			};
			this.checkedImminent = false;
			if (this.$refs.multiTable.$refs.baseTable.$refs.table) {
				this.$refs.multiTable.$refs.baseTable.$refs.table.sort(this.lastSortType === 3 ? 'commission_rate' : 'service_rate', '');
			}
			this.sort_desc = '';
			this.sortType = 0;
		},
		//商品列表
		getShopList: debounce(async function (isSearch) {
			const { sortType: sort_type, has_material, has_open_commission_rate, sort_desc } = this;
			this.isSearch = Boolean(isSearch);
			this.params.platform_id = this.platformId;
			this.params.has_open_commission_rate = has_open_commission_rate;
			this.params.has_material = has_material;
			this.loading = true;
			try {
				const { list = [], page = {}, data_empty, sync_info } = await productList({ ...this.params, sort_type, ...this.pageInfo, sort_desc });
				this.noGoods = data_empty;
				this.list = list.map(item => ({
					...item,
					operations: this.getButtons(item),
					shopLibrary: true,
				}));
				this.total = `${page.item_total}`;
				this.loading = false;
				this.sync_info = sync_info;
				this.$isPlatOr(['Dy', 'Ks']) && this.flowRecordNew();
			} catch (error) {
				this.loading = false;
			}
		}, 300),
		//操作按钮
		getButtons({ promote_status, is_self, is_del, source_type, hand_card, is_top, isPromoExtRecords, approval_status, commission_type }) {
			const arr = [];
			const { open, close } = promoteStatus;
			arr.push(
				{
					label: '重新分配',
					type: 'text',
					classtype: 2,
					notSelf: commission_type == 1 && this.platformId == 3,
					tooltipContent: commission_type == 1 && this.platformId == 3 ? '机构分配佣金类型的商品，请在“团长商品”模块中进行操作。' : '',
					isShow: this.$auth.hasPermi('system:goods:anew-goods'),
					click: row => {
						if (commission_type == 1 && this.platformId == 3) {
							return;
						}
						this.$refs.anewAllocationDialog.show(row);
					},
				},
				{
					label: '推广商品',
					type: 'text',
					isShow: this.$auth.hasPermi('system:goods:promote'),
					classtype: 2,
					icon: this.$auth.hasPermi('system:goods:promote') && '#icon-fenxiang',
					click: row => {
						this.timer = new Date().getTime();
						this.$nextTick(() => {
							this.$refs.shareDrawer.show(row);
						});
					},
				},
				{
					label: '快速申样',
					type: 'text',
					isShow: this.$auth.hasPermi('system:goods:sampleRequest'),
					classtype: 2,
					click: row => {
						this.$refs.applySampleDrawer.show([row], 'fast', row.product_type === '4');
					},
				},
				{
					type: 'copyLink',
					isShow: true,
					icon: '#icon-fuzhilianjie',
				},
				{
					label: '无样开播',
					type: 'text',
					isShow: true || this.$auth.hasPermi('system:goods:unsample-broadcasting'),
					classtype: 2,
					click: row => {
						this.$refs.sampleFreeBroadcastDrawer.show([row], 'fast');
					},
				},
				{
					label: '置顶',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:shopLibray:Pinned') && is_top === '0',
					click: async row => {
						const { code } = await setProductTop({ product_ids: row.product_id });
						if (code !== 0) return;
						this.$message.success('操作成功');
						this.getShopList();
					},
				},
				{
					label: '取消置顶',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:shopLibray:Pinned') && is_top === '1',
					click: async row => {
						const { code } = await delProductTop({ product_ids: row.product_id });
						if (code !== 0) return;
						this.$message.success('操作成功');
						this.getShopList();
					},
				},
				{
					label: '编辑商品机制',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:goods:editGoods-mechanism'),
					notSelf: !is_self,
					tooltipContent: '仅认领招商可修改',
					click: row => row.is_self && this.$refs.editShopDialog.editShop(row, this.columns),
					// click: row => this.$refs.editShopDialog.editShop(row, this.columns),
				},
				{
					label: hand_card ? '查看手卡' : '上传手卡',
					type: 'text',
					classtype: 2,
					isShow: hand_card || this.$auth.hasPermi('system:view-uploadHandCard'),
					notSelf: hand_card ? false : !(this.$auth.hasPermi('system:view-uploadHandCard') && is_self),
					icon: this.$auth.hasPermi('system:view-uploadHandCard') && (hand_card ? '#icon-shouka' : '#icon-shangchuanshouka'),
					click: row => {
						// 查看手卡没有权限控制，上传手卡 需要权限并且isSelf为1
						const canClick = hand_card || (this.$auth.hasPermi('system:view-uploadHandCard') && is_self);
						this.sysgenCard = row;
						if (canClick) {
							const func = hand_card ? 'seeHandCard' : 'handCard';
							this.$refs.handCardDialog[func](row);
						}
					},
				},
				{
					label: promote_status === open ? '关闭推广' : '开启推广',
					type: 'text',
					classtype: promote_status === open ? open : close,
					isShow: this.$auth.hasPermi('system:goods:extend'),
					notSelf: !is_self,
					tooltipContent: '仅认领招商可修改',
					click: row => row.is_self && this.extension(row),
				},
				{
					label: '取消认领',
					type: 'text',
					classtype: 2,
					notSelf: commission_type == 1 && this.platformId == 3,
					tooltipContent: commission_type == 1 && this.platformId == 3 ? '机构分配佣金类型的商品，请在“团长商品”模块中进行操作。' : '',
					isShow: !!is_self && source_type == 2 && this.$auth.hasPermi('system:goods:claim'),
					click: row => {
						if (commission_type == 1 && this.platformId == 3) {
							return;
						}
						this.cancelReceive(row);
					},
				},
				{
					label: '查看详情',
					type: 'text',
					isShow: this.$auth.hasPermi('system:shopLibraryDetails-query'),
					classtype: 2,
					click: row => {
						let handLink = this.$router.resolve({
							path: '/shopManage/shopLibrary/shopLibraryDetails',
							query: {
								productId: row.product_id,
								thirdProductId: row.third_product_id,
								platformId: row.platform_id,
							},
						});
						window.open(handLink.href, '_blank');
					},
				},
				{
					label: '修改素材',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:shopLibray:batch-add-material'),
					click: row => this.addMaterial(0, [row]),
				},
				{
					label: '备注',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:goods-remark'),
					notSelf: !is_self,
					tooltipContent: '仅认领招商可修改',
					click: row => row.is_self && this.$refs.remarkDialog.remark(row),
				},
				{
					label: '删除',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:shopLibray:deleteGood'),
					notSelf: !is_del,
					click: row => is_del && this.$refs.delDialog.delInit(row, menuType.library, '是否确认删除商品？', 'single_library'),
				},
				{
					label: '修改申样门槛',
					type: 'text',
					classtype: 2,
					isShow: this.$auth.hasPermi('system:goods-editSill'),
					notSelf: !((this.$auth.hasPermi('system:goods-editSill') && is_self) || this.$auth.hasPermi('system:goods-editSill')),
					tooltipContent: this.$auth.hasPermi('system:goods-editSill') ? '限招商运营本人/管理员可编辑' : '',
					click: row => this.$auth.hasPermi('system:goods-editSill') && this.$Bus.$emit('show', { mode: 'single', goods: [row] }),
				},
				{
					label: '延长推广',
					type: 'text',
					classtype: 2,
					isShow: isPromoExtRecords && this.$auth.hasPermi('system:shopLibray:Prolonging-good'),
					disabled: approval_status == 'pending',
					click: row => {
						this.$refs['dialogDelayPromotion'].show(row);
					},
				},
			);
			let filterArr = arr.filter(item => item.isShow);
			filterArr.tagDialog = this.addTag;
			return filterArr;
		},
		async cancelReceive({ is_cooperate, product_id, platform_id }) {
			let title = '取消认领';
			let text = '取消认领后，商品将回到“团长商品”列表中，团队其他成员可以进行认领。';
			if (is_cooperate) {
				title = `无法${title}`;
				text = `由于该商品正在合作中，无法取消认领，请联系团队管理员重新分配${this.zsName}！`;
			}
			try {
				await this.$confirm(text, title);
				if (is_cooperate) return;
				const { code } = await cancelReceive({ product_id, platform_id });
				if (code !== 0) return;
				this.$message.success('取消认领成功');
				this.getShopList();
			} catch (error) {}
		},
		unlimitedBroadcasting() {
			const { selectionShopArr } = this;
			if (!selectionShopArr.length) return;
			if (selectionShopArr.length > 10) return this.$message.warning('最多选择10个商品');
			this.$refs.sampleFreeBroadcastDrawer.show(selectionShopArr, 'multiple');
		},
		//回收站
		recycleFun() {
			let handLink = this.$router.resolve({
				path: '/shopManage/shopLibrary/waste',
			});
			window.open(handLink.href, '_blank');
		},
		async publicFun() {
			this.$refs.recommendDrawer.show([], 0);
		},
		// 商品流转出现弹窗
		showGoodsRecord() {
			this.$refs.flowGoodsDrawer.show();
		},
		//筛选
		onSubmit(val) {
			this.has_open_commission_rate = val.has_open_commission_rate || 0;
			this.sortType = val.sort_type || 0;
			this.has_material = val.has_material || 0;
			this.params = val;
			this.params.page_index = 1;
			this.params.page_size = 10;
			this.params.view_self = this.checked ? '1' : '0';
			this.$refs.multiTable.resetPage();
			this.getShopList(1);
		},
		//提交备注
		async saveRemark({ product_id, remark }) {
			let params = { product_id, remark };
			const { code } = await editField(params);
			if (code === 0) {
				this.$message.success('修改成功');
				this.getShopList();
				this.$refs.remarkDialog.hide();
			}
		},
		// 招商运营仅看自己商品
		onlyFun(e) {
			this.params.view_self = e ? '1' : '0';
			this.getShopList();
		},
		//推广
		async extension({ product_id, promote_status }) {
			const { open, close } = promoteStatus;
			let params = {
				product_id,
				promote_status: promote_status === open ? close : open,
			};
			if (promote_status === open) {
				await this.$confirm(
					'<div style="color:#333333">是否确认关闭推广？</div><div style="color:#333333">关闭推广后将无法以小程序形式将商品推荐给达人，但不影响后台申请样品、复制链接 等操作。</div>',
					'提示',
					{
						confirmButtonText: '确认审核',
						cancelButtonText: '取消',
						type: 'warning',
						dangerouslyUseHTMLString: true,
					},
				);
			}
			const { code } = await editField(params);
			const tip = promote_status === open ? '关闭成功' : '开启成功';
			if (code === 0) this.$message.success(tip);
			this.getShopList();
		},
		//选择商品
		selectionChange(val) {
			this.selectionShopArr = val;
			this.ids = val.map(item => item.product_id);
			this.setCardCheckList(val);
			const selectLength = this.selectionShopArr.length;
			this.allChecked = selectLength && selectLength === this.list.length;
		},
		//选中值
		checkeFun(e) {
			this.setTableCheckList(this.list, e);
			this.setCardCheckList(e ? this.list : []);
		},
		setTableCheckList(list, e) {
			this.$refs.multiTable.toggleSelection(this.list, false);
			this.$refs.multiTable.toggleSelection(list, e);
		},
		setCardCheckList(list) {
			this.$refs.productWrap.setCheckList(list.map(e => e.product_id));
		},
		gePartnerList({ page_index, page_size }) {
			this.pageInfo.page_index = page_index;
			this.pageInfo.page_size = page_size;
			this.$backTop();
			this.getShopList();
		},
		currentChange(val) {
			this.pageInfo.page_index = val;
			this.$backTop();
			this.getShopList();
		},
		sizeChange(val) {
			this.pageInfo.page_size = val;
			this.$backTop();
			this.getShopList();
		},
		batchSample() {
			const { selectionShopArr } = this;
			if (!selectionShopArr.length) return;
			if (selectionShopArr.length > 10) return this.$message.warning('最多选择10个商品');
			const isCommander = selectionShopArr.filter(item => item.product_type === '4').length; //是否含有二级团长商品
			this.$refs.applySampleDrawer.show(this.selectionShopArr, 'multiple', !!isCommander);
		},
		// 批量添加素材/修改素材
		addMaterial(batch = 0, goodsList = []) {
			if (goodsList.length) {
				const thirdProductId = !batch ? `&thirdProductId=${goodsList[0].third_product_id}` : '';
				localStorage.setItem('goodsList', JSON.stringify(goodsList.map(e => e.third_product_id).join(',')));
				this.$router.push(`/shopManage/shopLibrary/addMaterial?batch=${batch}&platformId=${this.platformId}${thirdProductId}`);
			}
		},
		async exportInterface(that) {
			that.$refs.exportDialog.show(this.exportDialog);
		},
		async exportDialog(value, option) {
			const { platformId: platform_id, routerPath, has_open_commission_rate, has_material } = this;
			this.params.has_open_commission_rate = has_open_commission_rate;
			this.params.has_material = has_material;
			const { code } = await productInfoExport({
				platform_id,
				type: 2,
				...this.params,
				export_img: Number(value),
				option,
				ids: this.ids,
				...this.pageInfo,
			});
			if (code === 0) {
				const handLink = this.$router.resolve({
					path: routerPath,
					query: { platform_id },
				});
				window.open(handLink.href, '_blank');
			}
		},
		recommend() {
			if (!this.selectionShopArr.length) return;
			let arr = JSON.parse(JSON.stringify(this.selectionShopArr));
			let list = arrSort(arr, 'total_sales');
			this.$refs.recommendDrawer.show(list, 1);
		},
		addTags() {
			if (!this.selectionShopArr.length) {
				this.$message.warning('请选择批量添加标签的商品');
				return;
			}

			this.$refs.tagDialog.show('批量添加标签', this.selectionShopArr);
		},
		addTag(row) {
			this.$refs.tagDialog.show('编辑标签', [row]);
		},
		async batchTop() {
			if (!this.selectionShopArr.length) return;
			let product_ids = this.selectionShopArr.map(item => item.product_id).join(',');
			const { code } = await setProductTop({ product_ids });
			if (code !== 0) return;
			this.$message.success('操作成功');
			this.getShopList();
		},
		synchroFun(platformId) {
			// const temPF = {
			// 	[dataMap.PLATFORM_DY.value]: () => this.$refs.goodsAsyncBtn.checkAuth(platformId),
			// 	[dataMap.PLATFORM_KS.value]: () => this.$refs.goodsAsyncBtn.checkAuth(platformId),
			// 	[dataMap.PLATFORM_SP.value]: () => this.$refs.goodsAsyncBtn.click(),
			// };
			// temPF[platformId]();

			this.$refs.goodsAsyncBtn.checkAuth(platformId);
		},
		onlyFunImminent() {
			this.$refs['search'].imminentSelect(this.checkedImminent);
		},
		clearImminent() {
			this.checkedImminent = false;
			this.pageInfo.page_index = 1;
		},
		onClear(val) {
			this.checkedImminent = false;
			this.has_open_commission_rate = val.has_open_commission_rate || 0;
			this.has_material = val.has_material || 0;
			this.params = val;
			this.params.page_index = 1;
			this.params.page_size = 10;
			this.params.view_self = this.checked ? '1' : '0';
			this.sortType = 0;
			this.sort_desc = '';
			this.$refs.multiTable.resetPage();
			if (this.$refs.multiTable.$refs.baseTable.$refs.table) {
				this.$refs.multiTable.$refs.baseTable.$refs.table.clearSort();
			}
			this.lastSortType = -1;
			this.gePartnerList({ page_index: 1, page_size: 10 });
		},
		searchClick(val) {
			if ([3, 4].includes(val)) {
				if (this.lastSortType != val) {
					this.sort_desc = '';
				}
				this.sort_desc = this.sort_desc === 'asc' ? 'desc' : 'asc';
				this.lastSortType = val;
				// 切换卡片模式 点击排序功能 需要把排序的状态更新到 table 上面
				if (this.$refs.multiTable.$refs.baseTable.$refs.table) {
					this.$refs.multiTable.$refs.baseTable.$refs.table.sort(
						val === 3 ? 'commission_rate' : 'service_rate',
						this.sort_desc === 'asc' ? 'ascending' : 'descending',
					);
				}
			} else {
				if (this.$refs.multiTable.$refs.baseTable.$refs.table) {
					this.$refs.multiTable.$refs.baseTable.$refs.table.clearSort();
				}
				this.sort_desc = '';
			}
			this.sortType = val;
			this.getShopList();
		},
		/**
		 * 批量分配商品
		 */
		bachDistribution() {
			const { selectionShopArr } = this;
			if (!selectionShopArr.length) {
				this.$message.warning('请选择批量分配的商品');
				return;
			}
			this.$refs.distribution.disInit(selectionShopArr);
		},
		onCommand(val) {
			this.sortType = val;
			this.getShopList();
		},
		/**批量延期推广*/
		extensionChange() {
			const { selectionShopArr } = this;
			if (!selectionShopArr.length) {
				this.$message.warning('请选择批量延期推广的商品');
				return;
			}
			this.$refs.extensionDrawer.show(selectionShopArr);
		},
		// 获取商品流转记录 是否有新的记录
		async flowRecordNew() {
			const data = await getProductClaimLogRecord({ platformId: this.platformId });
			this.showTips = data.showTips;
		},

		/**
		 * 批量删除商品
		 */
		batchDelete() {
			if (!this.selectionShopArr.length) {
				this.$message.warning('请选择批量删除商品的商品');
				return;
			}
			let product_ids = this.selectionShopArr.map(item => item.product_id).join(',');
			this.$refs.delDialog.delInit({ product_id: product_ids }, menuType.library, '是否确认批量删除商品？', 'batch_library');
		},

		// 排序
		onSort(val) {
			const { order, prop } = val;
			this.pageInfo.page_index = 1;
			if (order) {
				this.sort_desc = order === 'descending' ? 'desc' : 'asc';
				this.sortType = prop === 'commission_rate' ? 3 : prop === 'normal_commission_rate' ? 5 : 4;
				this.lastSortType = this.sortType;
			} else {
				this.sort_desc = '';
				this.sortType = 0;
			}

			this.getShopList();
		},

		/**
		 * 切换卡片/表格
		 */
		modeSwitch(val) {
			this.showTable = Boolean(val);
		},
		async getDoubleCommissionForPlugin(){
			if(!this.selectionShopArr.length) {
				this.$message.warning('请选择需要获取双佣信息的商品');
				return;
			}
			let selectArr = this.selectionShopArr.map(item => {
				return {
					activityId: item.outer_activity_id,
					productId: item.product_id,
				};
			});	
			console.log('调用插件获取双佣信息',selectArr);
			try {
				let paramsArr = selectArr.map(item => {
					return item.productId
				});
				await callPlug('plugGetBatchDoubleCommission', {});
				// 缓存同步任务
				await cacheDoubleCommissionProducts({ productIds: paramsArr });
				const res = await callPlug('plugGetBatchDoubleCommission', {});
				console.log('插件返回的双佣信息', res);
				this.$message({
					message: '提交任务成功，请稍后从商品库刷新页面查看',
					type: 'success',
				});
				this.getShopList();
			} catch (error) {
				console.log(error)
				// 清空其他弹窗信息
				this.$message.closeAll();
				this.$message({
					message: error?.msg || '获取失败',
					type: 'error',
				});
			}
		}
	},
	beforeDestroy() {
		this.$Bus.$off('applicationSetting');
	},
};
</script>
<style lang="less" scoped>
.tab-btn {
	padding-bottom: 0;
}

.line {
	width: 1px;
	height: 16px;
	background-color: #eee;
	margin: 0 10px;
}

.multi-table {
	position: relative;
	::v-deep .el-tabs__content {
		overflow: auto;
		min-height: 60vh;

		&::-webkit-scrollbar {
			width: 0;
		}
	}

	.switch-wrap {
		display: flex;
		align-items: center;

		.iconfont {
			font-size: 24px;
			cursor: pointer;
			color: #666;
			z-index: 9;

			&:hover {
				background-color: #f5f7fa;
			}

			&.active {
				color: @color-primary;
			}
		}
		.iconfont:hover {
			color: @color-primary;
		}
	}
}
.transfer-record {
	position: relative;
	z-index: 111;
	cursor: pointer;
	color: #666;
}
.transfer-record:hover {
	color: @color-primary;
}
.recycle-public {
	position: absolute;
	right: 30px;
	top: 15px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	.recycleBin {
		cursor: pointer;
		z-index: 999;
		color: #666;
	}

	.recycleBin:hover {
		color: @color-primary;
	}

	.public {
		position: relative;
		z-index: 1;
		cursor: pointer;
		display: flex;
		align-items: center;
	}

	.public:hover {
		color: @color-primary;
	}
}

.extraMb {
	padding-bottom: 180px;
}
.table-content {
	height: 0px !important;
	overflow: hidden;
	/deep/ .gm-scrollbar .thumb {
		// width: 800px !important;
	}
}
.active-table-content {
	height: auto !important;
	overflow: visible !important;
}
.muti-table {
	/deep/ .table-header-row {
		background: @color-gy3 !important;
	}
	/deep/ th.el-table__cell {
		// background: red;
		padding: 8px 0 8px 0px !important;
	}
	/deep/ .el-table__header {
		width: 100% !important;
	}
	/deep/ .table-header-row {
		tr {
			background: @color-gy3 !important;
		}
	}
	/deep/ .cell {
		font-size: 14px !important;
		color: @color-regular !important;
		font-weight: normal !important;
	}
}
.yx-background-white {
	position: absolute !important;
	right: 12px !important;
}
.product-wrap {
	padding-bottom: 80px;
}
</style>
<style lang="less">
.dropdownPop.el-dropdown-menu--small {
	padding: 10px 0;
	.el-dropdown-menu__item {
		line-height: 24px;
		padding: 3px 3px 3px 6px;
	}
	.el-dropdown-menu__item {
		button {
			border: none !important;
			background: none !important;

			color: @color-text-regular;
		}
	}
}
.red-dot {
	width: 8px;
	height: 8px;
	border-radius: 50%;
	background: @color-danger;
}
</style>
<style lang="less" scoped>
.tips-content {
	position: relative;
	/deep/ .el-icon-info {
		top: 1px !important;
	}
	/deep/ .el-icon-close {
		top: 50% !important;
		transform: translateY(-50%);
		right: 20px !important;
	}
}
.caret-block {
	display: block;
	line-height: 7px;
	color: @color-text-placeholder;
}
.public-disabled {
	cursor: not-allowed !important;
}
</style>
